<template>
  <div class="overlay2">
    <div class="overlay back">
    </div>
    <div class="masthead">
      <div class="masthead-bg"></div>
      <div class="container h-100">
        <div class="row h-50">
          <div class="col-12 my-auto">
            <div class="masthead-content text-white py-5 py-md-0">
              <h1><span class="not-found-icon nc-icon nc-notification-70"></span>Sin Registro</h1>
              <p>Estimado Ciudadano</p>
              <p>No se encuentra registrado en servel, por lo cual no podrá hacer uso de esta aplicación.</p>
              <p>Presione aceptar para salir de este sitio</p>
            </div>
          </div>
        </div>
        <div class="row h-30">
          <div class="col-12 my-5 text-center">
            <el-button type="primary" @click="logout" class="noexisteservelaceptar">Aceptar
              <slot></slot>
            </el-button>
          </div>
        </div>

        <div class="row h-30">
          <div class="col-12 my-auto">
            <div class="masthead-content text-white py-5 py-md-0">
              <p>Para mayor información, verifique su estado de vigencia en <a href="https://consulta.servel.cl/"
                                                                               target="_blank" rel="noopener noreferrer">aquí</a></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {Button} from "element-ui";

export default {
  name: "NoExisteEnServel",
  components: {
    [Button.name]: Button,
  },
  mounted() {
    let style = document.createElement('link');
    style.type = "text/css";
    style.rel = "stylesheet";
    style.href = '/css/coming-soon.css';
    document.body.appendChild(style);
  },
  methods: {
    logout() {
      this.$router.push({'path': '/logout'})
    }
  }
}
</script>

<style lang="scss" scoped>
.not-servel {
  .not-found-icon {
    margin-right: 10px;
  }

  .centered {
    h1, i {
      font-size: 50px;
    }

    p {
      font-size: 20px;
    }

    display: flex;
    padding-bottom: 150px;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: calc(100vh - 160px);
  }
}

.back {
  background-image: url(https://portalpartidos.servel.cl/img/background211.png);
  background-size: cover;
  background-position: bottom;
}

.overlay2 {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  z-index: 1;
}
</style>
